import { Spin } from "antd";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import { useGetDialDataQuery } from "@/redux/api/dashboardApi";

import { getDashboardFilterDate } from "@/utils/globalUtils";
import DialGuege from "../HomeCharts/DialGuege";
import Layout3DTank from "./Layout3DTank";
import LayoutCounter from "./LayoutCounter";
import LayoutDynamicBox from "./LayoutDynamicBox";
import LayoutLoadSummary from "./LayoutLoadSummary";
import LayoutSplitCounter from "./LayoutSplitCounter";
import Thermometer from "./Thermometer";

const COMPONENT_MAP = {
  dial: DialGuege,
  splitCounter: LayoutSplitCounter,
  tank: Layout3DTank,
  dynamicBox: LayoutDynamicBox,
  loadSummary: LayoutLoadSummary,
  thermometer: Thermometer,
  counter: LayoutCounter,
};

const DialFetch = ({ data, type, mainDashboard, dialChangeKey, isSelected }) => {
  const { dateRange } = useSelector((state) => state.dashboardV2);
  const { locations, operator, xAxis, timeRange } = data;

  const date = getDashboardFilterDate({ xAxis, timeRange });
  const dpIds = Array.isArray(locations?.yAxis) ? locations?.yAxis.join(",") : locations?.yAxis;

  let params = {
    ...date,
    // device: locations?.device,
    operator,
    peakHours: dateRange.peakHours,
    // Only the Load Summary card shows a peak; skipping it keeps other dial requests cheap
    ...(type === "loadSummary" ? { includePeak: true } : {}),
    deviceParameter: JSON.stringify({ _id_in: dpIds, populate: "systemFormula systemParameter device" }),
  };

  const yAxis = locations?.yAxis;
  const { data: apiData, isFetching, isLoading } = useGetDialDataQuery(params, { skip: !yAxis });

  const Component = COMPONENT_MAP[type];

  return (
    <div className="w-100 h-100 position-relative">
      <Spin spinning={isLoading || isFetching} wrapperClassName="w-100 h-100 h-100-spin" style={{ height: "100%", display: "block" }}>
        <div className="w-100 h-100">
          {Component && (
            <Component
              data={data}
              type={type}
              mainDashboard={mainDashboard}
              dialChangeKey={dialChangeKey}
              isSelected={isSelected}
              apiData={apiData}
            />
          )}
        </div>
      </Spin>
    </div>
  );
};

export default DialFetch;

DialFetch.propTypes = {
  data: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  mainDashboard: PropTypes.bool,
  dialChangeKey: PropTypes.number,
  isSelected: PropTypes.bool,
};
